import { AuthInterceptor, AuthService, IdbService } from '@lg/ng-shared'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BlockNamePipe } from './pipes/block-name.pipe.js'
import { EditModule } from './edit/edit.module.js'
import { BrowserModule } from '@angular/platform-browser'
import { SharedStudioModule } from './shared/shared.studio.module.js'
import { NgModule } from '@angular/core'

import { AppRoutingModule } from './app-routing.module.js'
import { AppComponent } from './app.component.js'
import { ErrorFileNotFoundComponent } from './shared/error-file-not-found/error-file-not-found.component.js'
import { NoStudioAccessComponent } from './shared/no-studio-access/no-studio-access.js'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { RouteReuseStrategy } from '@angular/router'
import { AppTrpcServiceInjectionToken } from '@lg/ng-shared'
import { StudioTrpcService } from '@lg/ng-shared'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { CsrfService } from '@lg/ng-shared'
import { EditorHelperServiceInjectionToken } from './injection-tokens.js'
import { EditorHelperService } from './edit/editor-helpers/editor-helper.service.js'
import { QuickActionsModule } from './shared/modules/quick-actions/quick-actions.module'
import { QUICK_ACTION_PROVIDER } from './shared/modules/quick-actions/constants/quick-action-provider.const'
import { EditActionProvider } from './providers/edit-action/edit-action.provider'
import { GlobalSearchComponent } from './shared/global-search/global-search.component'

@NgModule({
	declarations: [
		AppComponent,
		ErrorFileNotFoundComponent,
		BlockNamePipe,
		NoStudioAccessComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		SharedStudioModule,
		AppRoutingModule,
		QuickActionsModule,
		GlobalSearchComponent,
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: AppTrpcServiceInjectionToken, useExisting: StudioTrpcService },
		{ provide: AuthService, useClass: AuthService },
		{ provide: CsrfService, useClass: CsrfService },
		{ provide: IdbService, useClass: IdbService },
		{
			provide: EditorHelperServiceInjectionToken,
			useClass: EditorHelperService,
		},
		// { provide: RouteReuseStrategy, useClass: StudioRouteReuseStrategy },
		provideHttpClient(withInterceptorsFromDi()),
		{
			provide: QUICK_ACTION_PROVIDER,
			useExisting: EditActionProvider,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
